import { AccountAboutCard } from '@playbooks/components/account/account-about-card';
import { AccountDropUsage } from '@playbooks/components/account/account-drop-usage';
import { AccountNavigationList } from '@playbooks/components/account/account-navigation-list';

const AccountDropAbout = ({ account, accountType, profileHref, target, onView, onLogout }) => {
	// Render
	return (
		<>
			<div className='border-b border-border p-1'>
				<AccountAboutCard
					account={account}
					accountType={accountType}
					href={profileHref}
					onClick={() => onView('select')}
				/>
			</div>
			<AccountDropUsage account={account} />
			<AccountNavigationList signedIn profileHref={profileHref} target={target} onView={onView} onLogout={onLogout} />
		</>
	);
};

export { AccountDropAbout };
